// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"67bca0a5","453":"3994709b","720":"4a6ea1fe"}[chunkId] + ".chunk.js";
};